import { render } from "./MasterDataTableForm.vue?vue&type=template&id=c8f4500e&scoped=true&ts=true"
import script from "./MasterDataTableForm.vue?vue&type=script&lang=ts"
export * from "./MasterDataTableForm.vue?vue&type=script&lang=ts"

import "./MasterDataTableForm.vue?vue&type=style&index=0&id=c8f4500e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f4500e"]])

export default __exports__